export const Connector = ({
  connector,
  handleClickConnector
}: {
  connector: any;
  handleClickConnector: any;
}) => {
  return (
    <>
      <span
        onClick={() => handleClickConnector(connector)}
        className={`${
          connector.selected
            ? 'border-[#E7811D] border-[2px] drop-shadow__connectors-selected'
            : 'border-[#788AA6] drop-shadow__Login'
        } cursor-pointer w-auto max-w-[100px] min-w-[80px] h-[80px] bg-[#fff] rounded-[10px] border-[1px] flex flex-col justify-center items-center ${
          connector.icon === 'salesforcemarketing' ? 'pl-[6px] pr-1.5' : 'pl-[1.85rem] pr-[2rem]'
        } `}>
        <img
          src={`/icons/connectors/${connector.icon}.png`}
          alt="reports-bar"
          className="h-auto w-auto min-h-[26px] min-w-[26px] max-h-[40px] pt-1.5 pb-2"
        />
        <span className="text-[10px] text-center leading-3">{connector.name}</span>
      </span>
    </>
  );
};
